import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { Link } from '@sc/types';
import { SessionsService } from '../sessions/sessions.service';
import { CloudFunctionsService } from '../cloud-functions.service';

@Injectable({
  providedIn: 'root',
})
export class LinksService {
  image = 'https://squadcast.fm/wp-content/uploads/2021/01/SC_V3SocialImage.png';

  constructor(private cfs: CloudFunctionsService, private sessionsService: SessionsService) {}

  async getShortLink(link: Link): Promise<string> {
    return JSON.stringify(
      await this.cfs.post('shortlinks-create', {
        url: link.url,
        title: link.title,
        description: link.description,
        imageUrl: link.imageUrl ?? this.image,
      })
    );
  }

  async getSquadshotShareLink(url: string, sessionID: string) {
    const session: any = await firstValueFrom(this.sessionsService.getSessionByID(sessionID));
    const shortLinkResponse = await this.getShortLink({
      url,
      title: `${session.showTitle} | ${session.sessionTitle} | Squadshot`,
      description: `Recorded on SquadCast.fm`,
      imageUrl: url,
    });
    return JSON.parse(shortLinkResponse).shortLink;
  }
}
